module.exports = __webpack_public_path__ + "media/images/admin/dropzone/move-6b2963830c41c7a99c397057ab838237.png";